const getConfigurableProductStockStatuses = (variants, currentVariantSku) => {
    const variant = variants === null || variants === void 0 ? void 0 : variants.find(({ product }) => product.sku === currentVariantSku);
    return (variant === null || variant === void 0 ? void 0 : variant.product.stock_status) === "IN_STOCK";
};
export const getStockStatus = (currentVariantSku, data = {}) => {
    const { __typename = "", stock_status = "", variants } = data;
    if (__typename === "ConfigurableProduct") {
        return getConfigurableProductStockStatuses(variants, currentVariantSku);
    }
    return stock_status === "IN_STOCK";
};
//# sourceMappingURL=getStockStatus.js.map